import type { CityConfig } from "../city-template/types";

export const gadsdenALConfig: CityConfig = {
  city: "Gadsden",
  state: "Alabama",
  stateAbbr: "AL",
  slug: "gadsden-al",
  route: "/cities/gadsden-al",
  title: "Emergency Passport Gadsden, AL | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Gadsden, AL — as fast as 24 hours. Serving Etowah County and Northeast Alabama. A+ BBB rated registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Gadsden, AL",
  heroSubtitle: "Northeast Alabama business trip to Germany with one week notice? Noccalula Falls family vacation to Canada and your passport expired? Coosa River fishing trip to the Caribbean need fast documents? We help Gadsden residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20view%20of%20Gadsden%20Alabama%20with%20Noccalula%20Falls%20waterfall%20natural%20landmark%20Coosa%20River%20flowing%20through%20the%20city%20historic%20downtown%20area%20Appalachian%20foothills%20lush%20green%20forest%20landscape%20golden%20hour%20warm%20sunset%20light%20professional%20photography%20soft%20tones%20Southern%20charm&width=1800&height=700&seq=gadsden-al-hero-2026&orientation=landscape",
  heroImageAlt: "Gadsden Alabama with Noccalula Falls and Coosa River at golden hour",
  geoPosition: "34.0076;-86.0102",
  geoPlacename: "Gadsden, Alabama",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 130 miles southeast of Gadsden via I-59/I-20",
  },
  nearbyCitiesZips: [
    { name: "Gadsden", zips: "35901, 35903, 35904" },
    { name: "Rainbow City", zips: "35906" },
    { name: "Attalla", zips: "35954" },
    { name: "Southside", zips: "35907" },
    { name: "Glencoe", zips: "35905" },
    { name: "Hokes Bluff", zips: "35903" },
    { name: "Anniston", zips: "36201, 36206, 36207" },
    { name: "Oxford", zips: "36203" },
    { name: "Albertville", zips: "35950, 35951" },
    { name: "Boaz", zips: "35956, 35957" },
    { name: "Fort Payne", zips: "35967" },
    { name: "Centre", zips: "35960" },
    { name: "Oneonta", zips: "35121" },
    { name: "Cedartown", zips: "30125" },
    { name: "Rome", zips: "30161, 30165" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Northeast Alabama departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Coosa River Valley", desc: "Serving Gadsden, Rainbow City, Attalla, and Northeast AL" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Birmingham, AL", route: "/cities/birmingham" },
    { name: "Fast passport renewal in Atlanta, GA", route: "/cities/atlanta" },
    { name: "Emergency passport help in Chattanooga, TN", route: "/cities/chattanooga" },
    { name: "Urgent passport services in Huntsville, AL", route: "/cities/huntsville" },
    { name: "Same-day passport help in Montgomery, AL", route: "/cities/montgomery-al" },
    { name: "Passport courier services in Anniston, AL", route: "/anniston" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Gadsden remotely via secure courier. We do not have a walk-in office in Gadsden — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Etowah County and Northeast Alabama.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Etowah County and Northeast Alabama including Calhoun, Marshall, and DeKalb counties",
  serviceAreaIntro: "From the iconic Noccalula Falls and the Coosa River waterfront in Gadsden to the quiet streets of Rainbow City, from the historic downtown of Attalla to the growing community of Southside, from the Appalachian foothills of Hokes Bluff and Glencoe to the county seat of Centre — Fast Passport Center serves the entire Northeast Alabama and Coosa River Valley region. We regularly help travelers from Etowah County and surrounding areas get their passports fast without the 130-mile drive to Atlanta.",
  nearbyCitiesIntro: "We serve all Gadsden neighborhoods and the surrounding Northeast Alabama area including Rainbow City, Attalla, Southside, Glencoe, Hokes Bluff, Anniston, Oxford, and Albertville. If you are anywhere in Etowah County, Calhoun County, or the Coosa River Valley, we have you covered.",
  howItWorksIntro: "Most Gadsden travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Gadsden travelers often face a 2+ hour drive to the nearest regional passport agency in Atlanta. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Gadsden and Etowah County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Gadsden? Here are the most common ones we hear from Northeast Alabama travelers.",
  statePageRoute: "/states/alabama",
  statePageName: "Alabama",
  dmvWebsite: "https://www.alea.gov/driver-license",
  dmvLabel: "AL Law Enforcement Agency — Driver License Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Gadsden travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Darlene K.",
      location: "Gadsden, AL",
      rating: 5,
      text: "Our Germany trip was in 4 days and I discovered my passport was expired. Fast Passport Center got me renewed in 28 hours. From Noccalula Falls to the Bavarian Alps in under a week — couldn't believe it was possible!",
      service: "Passport Renewal",
    },
    {
      name: "Mike W.",
      location: "Rainbow City, AL",
      rating: 5,
      text: "Medical emergency in Canada — had to get to my daughter in Toronto. Fast Passport Center got my passport in 24 hours. The dedicated agent handled everything while I packed. Amazing for Northeast Alabama.",
      service: "Emergency Passport",
    },
    {
      name: "Donna P.",
      location: "Southside, AL",
      rating: 5,
      text: "Grandkids needed passports for a cruise to the Bahamas. Fast Passport Center walked us through the child passport process. All three done in 5 days. Etowah County families need to know about this!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "gadsden-al-1",
      name: "Gadsden Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "700 Chestnut St",
      city: "Gadsden",
      state: "AL",
      zip: "35901",
      phone: "(256) 547-6001",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Gadsden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Gadsden facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "gadsden-al-2",
      name: "Etowah County Circuit Clerk",
      type: "County Circuit Clerk Passport Acceptance",
      address: "801 Forrest Ave",
      city: "Gadsden",
      state: "AL",
      zip: "35901",
      phone: "(256) 549-5354",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Gadsden Courthouse",
      website: "https://www.etowahcounty.org",
      websiteLabel: "Etowah County Circuit Clerk",
      notes: "Accepts passport applications at the courthouse. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "gadsden-al-3",
      name: "Rainbow City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "103 Rainbow Dr",
      city: "Rainbow City",
      state: "AL",
      zip: "35906",
      phone: "(256) 442-1004",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles south of Gadsden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Rainbow City and south Etowah County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "gadsden-al-4",
      name: "Attalla Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 5th Ave NW",
      city: "Attalla",
      state: "AL",
      zip: "35954",
      phone: "(256) 538-2941",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles west of Gadsden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Attalla. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "gadsden-al-5",
      name: "Anniston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1101 Quintard Ave",
      city: "Anniston",
      state: "AL",
      zip: "36201",
      phone: "(256) 236-6431",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles south of Gadsden",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Anniston and Calhoun County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2+ hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Gadsden photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Etowah County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Gadsden applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Atlanta regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Northeast Alabama families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Gadsden travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Gadsden." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Gadsden address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Gadsden before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Gadsden for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 2+ hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Gadsden?", a: "Fast Passport Center offers fast passport renewal in Gadsden in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Gadsden?", a: "The nearest regional passport agency to Gadsden is the Atlanta Passport Agency, approximately 130 miles southeast via I-59/I-20. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Gadsden without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Gadsden?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 2+ hours from Gadsden — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Etowah County and Northeast Alabama residents." },
    { q: "Do you serve the entire Etowah County area?", a: "Absolutely. Fast Passport Center serves the entire Northeast Alabama and Coosa River Valley region including Gadsden, Rainbow City, Attalla, Southside, Glencoe, Hokes Bluff, and surrounding areas. Our courier service works seamlessly from any address in Etowah County or Calhoun County." },
    { q: "Can I expedite a child passport in Gadsden?", a: "Yes. Fast Passport Center expedites child passports in Gadsden for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Northeast Alabama families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Gadsden with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Gadsden", address: "340 E Meighan Blvd, Gadsden, AL 35903", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Gadsden", address: "300 E Meighan Blvd, Gadsden, AL 35903", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Gadsden", address: "1100 E Meighan Blvd, Gadsden, AL 35903", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Anniston", address: "5560 McClellan Blvd, Anniston, AL 36206", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "ALEA Driver License Office — Gadsden",
      address: "200 Wilson St, Gadsden, AL 35904",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Primary ALEA office for Etowah County. Driver license and REAL ID. Appointment recommended.",
      featured: true,
    },
    {
      name: "ALEA Driver License Office — Anniston",
      address: "410 18th St N, Anniston, AL 36202",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Calhoun County. REAL ID available.",
      featured: false,
    },
    {
      name: "ALEA Driver License Office — Fort Payne",
      address: "550 DeKalb County Industrial Blvd, Fort Payne, AL 35968",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves DeKalb County. About 35 minutes north.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BHM",
      name: "Birmingham-Shuttlesworth International Airport",
      distance: "65 miles southwest of Gadsden",
      address: "5900 Messer Airport Hwy, Birmingham, AL 35212",
      note: "Major Alabama airport with direct flights nationwide. About 1 hour from Gadsden.",
      flightUrl: "https://www.flybirmingham.com/",
      flightLabel: "BHM Airport",
      featured: true,
    },
    {
      code: "ATL",
      name: "Hartsfield-Jackson Atlanta International Airport",
      distance: "130 miles southeast of Gadsden",
      address: "6000 N Terminal Pkwy, Atlanta, GA 30320",
      note: "Major international hub with flights worldwide. About 2 hours 15 minutes from Gadsden.",
      flightUrl: "https://www.atl.com/",
      flightLabel: "ATL Airport",
      featured: false,
    },
    {
      code: "HSV",
      name: "Huntsville International Airport",
      distance: "85 miles northwest of Gadsden",
      address: "1000 Glenn Hearn Blvd SW, Huntsville, AL 35824",
      note: "North Alabama airport with direct flights to hubs nationwide. About 1 hour 30 minutes from Gadsden.",
      flightUrl: "https://www.flyhuntsville.com/",
      flightLabel: "HSV Airport",
      featured: false,
    },
  ],
};